module.exports = __webpack_public_path__ + "img/video-poster_1576231362701.2593cc16.png";